import { PATH } from '~/links'

export const onOtcPath = (): boolean => window.location && window.location.pathname.startsWith(`/${PATH.ROOT_OTC}`)
